import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMessages } from "../../../redux/slices/messagesSlice";
import { Table } from "react-bootstrap";

const Inbox = () => {
  const dispatch = useDispatch();
  const { inbox = [], isLoading, error } = useSelector((state) => state.messages);
  
  useEffect(() => {
    dispatch(fetchMessages());
  }, [dispatch]);

  if (isLoading) return <p>Loading inbox...</p>;
  if (error) return <p className="text-danger">Error: {error}</p>;

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>From</th>
          <th>Content</th>
          <th>Sent At</th>
        </tr>
      </thead>
      <tbody>
        {inbox.map((message, index) => (
          <tr key={message.id}>
            <td>{index + 1}</td>
            <td>{message.sender.name || "desconhecido"}</td>
            <td>{message.content}</td>
            <td>{new Date(message.sent_at).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default Inbox;